export default __webpack_public_path__ + "static/media/6_Absturz.a60aca40.png";